var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('a',{staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"title":"点击下载","target":"_blank","href":_vm.file
          ? _vm.url
          : _vm.OssCofing.prefixUrl +
            _vm.OssCofing.folder +
            'certificate/' +
            _vm.factoryInfo.detail.new_number +
            '/' +
            _vm.detail.file,"download":_vm.detail.file}},[_vm._v(" 点击下载 ")]),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.$refs.upload.click()}}},[_vm._v("重新上传 ")]),_c('input',{ref:"upload",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.upload}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }